<template>
  <div class="container-fluid">
    <div class="row mt-4">
      <div class="col-8">
        <select-empresa-caixa
          :comTodos="true"
          :noStyle="false"
          :empresa="empresaSelecionada.cod_empresa"
          @empresa="selectEmpresa"
          @caixa="selectCaixa"
          :caixa="caixaSelecionado.cod_caixa ?? null"
        ></select-empresa-caixa>
      </div>
      <div class="col-4">
        <label>Data</label>
        <b-input type="date" class="form-control" v-model="data"></b-input>
      </div>
    </div>
    <hr />
    <div class="card p-0 py-3">
      <b-tabs
        vertical
        pills
        nav-class="bg-light p-0"
        active-nav-item-class="bg-info"
        nav-wrapper-class="bg-red p-0 pl-2"
        bottom
        justified
        card
      >
        <b-tab title="Resumo">
          <template #title>
            <div
              class="d-flex justify-content-center align-items-center flex-column text-center"
            >
              <b-icon icon="cash-stack"></b-icon>
              <span>Resumo</span>
            </div>
          </template>
          <div class="col-12">
            <div v-if="loading">
              <b-skeleton height="200px"></b-skeleton>
            </div>
            <div v-if="!loading">
              <b-card-title>
                <div class="d-flex justify-content-between">
                  <div>
                    <i class="fa fa-cash-register mr-1"></i>
                    {{ caixaSelecionado.nome ?? "Caixa" }}
                  </div>
                  <div class="d-flex justify-content-end">
                    <b-button
                      variant="success"
                      @click="openModalAbertura"
                      class="ml-2"
                      v-if="
                        !caixaControle || caixaControle.dt_fechamento === null
                      "
                    >
                      <i class="fa fa-cash-register mr-1"></i>
                      {{ caixaAberto ? "Fechar Caixa" : "Abrir Caixa" }}
                    </b-button>
                    <b-button
                      variant="warning"
                      @click="openModalSangria"
                      class="ml-2"
                      v-if="
                        !caixaControle || caixaControle.dt_fechamento === null
                      "
                    >
                      <i class="fa fa-arrow-down mr-1"></i>
                      Registrar Sangria
                    </b-button>
                    <small
                      v-if="
                        caixaControle && caixaControle.dt_fechamento !== null
                      "
                      style="font-size: 10px"
                    >
                      Caixa fechado em
                      {{
                        caixaControle.dt_fechamento | moment("DD/MM/YYYY HH:mm")
                      }}
                      <b-button
                        variant="danger"
                        @click="cancelFechamento"
                        class="ml-2"
                      >
                        <i class="fa fa-cash-register mr-1"></i>
                        Re-abrir Caixa
                      </b-button>
                    </small>
                    <b-button variant="primary" @click="printFita" class="ml-2">
                      <i class="fa fa-print mr-1"></i>
                      Imprimir Fita
                    </b-button>
                  </div>
                </div>
              </b-card-title>
              <b-card-text>
                <b-list-group>
                  <b-list-group-item
                    class="d-flex justify-content-between bg-light"
                  >
                    <strong>Abertura</strong>
                    <div class="d-flex align-items-center">
                      <b-button
                        size="sm"
                        variant="link"
                        class="p-0 mr-2"
                        @click="() => openModalAbertura(1)"
                        v-if="caixaControle"
                      >
                        <i class="fa fa-edit text-info"></i>
                      </b-button>
                      {{ valorAbertura | currency }}
                    </div>
                  </b-list-group-item>
                  <b-list-group-item
                    v-for="(value, key) in porForma"
                    :key="key"
                    class="d-flex justify-content-between"
                  >
                    <div>{{ key }}</div>
                    <div>
                      {{ value | currency }}
                    </div>
                  </b-list-group-item>
                  <b-list-group-item
                    class="d-flex justify-content-between bg-light"
                  >
                    <strong>Total</strong>
                    <div>
                      {{
                        lista.reduce((acc, item) => acc + item.total, 0)
                          | currency
                      }}
                    </div>
                  </b-list-group-item>
                  <!-- Saídas/Sangrias -->
                  <b-list-group-item
                    v-if="saidas && saidas.length > 0"
                    class="bg-danger text-white mt-2"
                  >
                    <strong>Saídas / Sangrias</strong>
                  </b-list-group-item>
                  <b-list-group-item
                    v-for="(saida, index) in saidas"
                    :key="'saida-' + index"
                    class="d-flex justify-content-between"
                  >
                    <div>
                      <i class="fa fa-arrow-down mr-1"></i>
                      Sangria
                      <small v-if="saida.motivo">({{ saida.motivo }})</small>
                    </div>
                    <div class="d-flex align-items-center">
                      <b-button
                        size="sm"
                        variant="link"
                        class="p-0 mr-2"
                        @click="editarSaida(saida)"
                      >
                        <i class="fa fa-edit text-info"></i>
                      </b-button>
                      <b-button
                        size="sm"
                        variant="link"
                        class="p-0 mr-2"
                        @click="excluirSaida(saida)"
                      >
                        <i class="fa fa-trash text-danger"></i>
                      </b-button>
                      {{ saida.valor | currency }}
                    </div>
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="saidas && saidas.length > 0"
                    class="d-flex justify-content-between bg-light"
                  >
                    <strong>Total em caixa</strong>
                    <div>
                      {{
                        (parseFloat(valorAbertura) +
                          lista.reduce((acc, item) => acc + item.total, 0) -
                          saidas.reduce(
                            (acc, item) => acc + parseFloat(item.valor),
                            0
                          ))
                          | currency
                      }}
                    </div>
                  </b-list-group-item>
                  
                  <!-- Motos / Entregas -->
                  <b-list-group-item
                    v-if="motos && motos.length > 0"
                    class="bg-info text-white mt-2"
                  >
                    <strong>Entregas / Motoboys</strong>
                  </b-list-group-item>
                  <b-list-group-item
                    v-for="(moto, index) in motos"
                    :key="'moto-' + index"
                    class="d-flex justify-content-between"
                  >
                    <div>
                      <i class="fa fa-motorcycle mr-1"></i>
                      {{ moto.moto }}
                      <small>({{ moto.qtd_total }} entregas)</small>
                    </div>
                    <div class="text-right">
                      <ul>
                        <li v-for="(p,n) in moto.porValor" :key="n">
                          {{ p.qtd }} x {{ p.vl_entrega | currency }} = {{ (p.qtd * p.vl_entrega) | currency }}
                        </li>
                      </ul>
                      <hr />
                       {{ moto.vl_pagamento | currency }}
                      
                      </div>
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="motos && motos.length > 0"
                    class="d-flex justify-content-between bg-light"
                  >
                    <strong>Total motoboys</strong>
                    <div>
                      {{ motos.reduce((acc, moto) => acc + parseFloat(moto.vl_pagamento || 0), 0) | currency }}
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </b-card-text>
            </div>
          </div>
        </b-tab>
        <b-tab title="Listagem">
          <template #title>
            <div
              class="d-flex justify-content-center align-items-center flex-column text-center"
            >
              <b-icon icon="list"></b-icon>
              <span>Listagem</span>
            </div>
          </template>
          <div class="d-flex justify-content-end mb-2">
            <b-button variant="primary" @click="loadData">
              <i class="fa fa-refresh"></i>
              Atualizar
            </b-button>
            <b-button variant="primary" @click="print" class="ml-2 mr-2">
              <i class="fa fa-print"></i>
              Imprimir
            </b-button>
            <export-excel :data="relatorioExcel">
              <b-btn variant="info">
                <i class="fa fa-file-excel mr-1"></i> Exportar
              </b-btn>
            </export-excel>
          </div>
          <b-skeleton-table v-if="loading"></b-skeleton-table>
          <div id="printDiv" v-if="!loading">
            <h3 class="text-center">Listagem de Caixa</h3>
            <h5 class="text-center">
              {{ empresaSelecionada.nome }} - {{ caixaSelecionado.nome }}
            </h5>
            <h5 class="text-center">{{ data | moment("DD/MM/YYYY") }}</h5>
            <hr />
            <b-table
              v-if="!loading"
              :items="lista"
              :fields="fields"
              hover
              striped
              select-mode="single"
              selectable
              @row-selected="openPedido"
              ref="tbLista"
            >
              <template #cell(data)="row">
                {{ row.value | moment("DD/MM/YYYY HH:mm") }}
                <div>
                  <small>
                    <i class="fa fa-headset mr-1"></i>
                    {{ row.item.usuario }}
                  </small>
                </div>
              </template>
              <template #cell(total)="row">
                {{ row.value | currency }}
              </template>
              <template #cell(ident)="row">
                <div class="text-left" style="min-width: 200px">
                  <span v-if="row.value.includes('|')">
                    {{ row.value.split("|")[0] }}
                    <div v-if="row.value.split('|')[1].trim() != ''">
                      <small
                        ><i class="fa fa-user mr-1"></i
                        >{{ row.value.split("|")[1] }}</small
                      >
                    </div>
                  </span>
                  <span v-if="!row.value.includes('|')">
                    <span v-if="row.item.tipo == 'Pedido'">
                      <i class="fa fa-shopping-cart mr-1"></i>
                    </span>
                    <span v-if="row.item.tipo == 'Mesa'">
                      <i class="fa fa-barcode mr-1"></i>
                    </span>
                    {{ row.value }}
                  </span>
                </div>
                <div class="text-left" style="font-size: 10px">
                  <small v-if="row.item.obs && row.item.obs.trim() != ''"
                    ><i class="fa fa-comment mr-1"></i>{{ row.item.obs }}</small
                  >
                </div>
              </template>
            </b-table>

            <div class="row">
              <div class="col-12 text-right bg-light">
                <b-skeleton
                  v-if="loading"
                  width="50"
                  style="width: 60px"
                  height="30"
                ></b-skeleton>
                <div v-if="!loading" class="p-3">
                  <h4>
                    <small><small class="mr-1">Total</small></small>
                    <b>
                      {{
                        lista.reduce((acc, item) => acc + item.total, 0)
                          | currency
                      }}
                    </b>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <b-modal
      id="modal-open-comanda"
      size="xl"
      hide-footer
      :modal-class="
        $store.state.isMobile ? `modal-full p-0 ` : 'modal-full p-0'
      "
      :body-class="`p-0`"
      :content-class="`p-0 ${$store.state.isMobile ? `fixed` : 'fixed'}`"
    >
      <mesa-new
        :mesa="mesaSelected"
        :blocked="true"
        :hideMesaMenu="true"
        @closeMesa="() => $bvModal.hide('modal-open-comanda')"
      ></mesa-new>
    </b-modal>
    <b-modal
      id="modal-open-pedido"
      size="xl"
      :content-class="'prodModal'"
      body-class="insideModal p-0 pt-2"
      hide-footer
      class="prodModal"
    >
      <Pedido :PedidoOpen="pedidoSelected"></Pedido>
    </b-modal>

    <!-- Modal Sangria -->
    <b-modal
      id="modal-sangria"
      :title="saidaEmEdicao ? 'Editar Sangria' : 'Registrar Sangria'"
      @ok="confirmarSangria"
      @hidden="resetModalSangria"
    >
      <div class="form-group">
        <label>Valor da Sangria</label>

        <money
          class="form-control p-3"
          v-model="valorSangria"
          size="sm"
          v-bind="money"
        />
      </div>
      <div class="form-group">
        <label>Motivo</label>
        <b-textarea
          v-model="motivoSangria"
          placeholder="Informe o motivo da sangria"
        ></b-textarea>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SelectEmpresaCaixa from "../../components/common/SelectEmpresaCaixa.vue";
// import EmpresaCombo from '../../components/empresa/EmpresaCombo.vue'
import moment from "moment";
// import CaixaLib from "@/libs/Caixas";
import PrinterWindowHelper from "../../utils/PrinterWindowHelper";
// import Caixa from "@/libs/Caixas";
import EmpresasLib from "@/libs/EmpresasLib";
import MesaNew from "../mesas/MesaNew.vue";
import Mesalib from "@/libs/MesaLib";
import Pedido from "../../components/pedido/Pedido.vue";
import PedidoLib from "../../libs/Pedido";
import CaixaLib from "../../libs/Caixas";
// import MotosLib from "../../libs/MotoLib";
// import MoneyInput from "../../components/common/MoneyInput.vue";
export default {
  components: {
    //   EmpresaCombo,
    SelectEmpresaCaixa,
    MesaNew,
    Pedido,
    // MoneyInput,
  },
  props: {},
  mounted() {
    console.log("empresas", this.empresas);
    this.carregaCaixas();
    this.loadData();
    // this.verificarStatusCaixa();
  },
  data() {
    return {
      caixas: [],
      empresas: [
        this.$store.state.empresas,
        ...(this.$store.state.empresas.empresas
          ? this.$store.state.empresas.empresas
          : []),
      ],
      empresaSelecionada: this.$store.state.empresa_ativa,
      caixaSelecionado: { ...this.$store.state.caixa_ativo },
      data: moment().format("YYYY-MM-DD"),
      lista: [],
      loading: true,
      fields: [
        { key: "data", label: "Data" },
        { key: "cod", label: "Código" },
        { key: "tipo", label: "Tipo" },
        { key: "ident", label: "Identificação" },
        { key: "pagamento", label: "Forma" },
        { key: "total", label: "Valor" },
      ],
      pedidoSelected: null,
      mesaSelected: null,
      // Novas propriedades para modais
      caixaAberto: false,
      valorAbertura: "R$ 0,00",
      obsAbertura: "",
      valorSangria: "R$ 0,00",
      motivoSangria: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
      },
      caixaControle: null,
      saidas: [],
      saidaEmEdicao: null,
      motos: [],
    };
  },
  watch: {
    empresaSelecionada() {
      this.caixaSelecionado = this.empresaSelecionada.caixas[0];
      this.loadData();
      this.loadSaidas();
      this.verificarAberturaCaixa();
      this.loadMotos();
      // this.verificarStatusCaixa();
    },
    caixaSelecionado() {
      // this.caixaSelecionado = this.empresaSelecionada.caixas.find((x) =>
      //   x.cod_caixa == this.caixaSelecionado
      //     ? this.caixaSelecionado.cod_caixa
      //     : 1
      // );
      // this.loadData();
      // this.verificarStatusCaixa();
      this.loadData();
      this.loadSaidas();
      this.verificarAberturaCaixa();
      this.loadMotos();
    },
    data() {
      this.loadData();
      this.loadSaidas();
      this.verificarAberturaCaixa();
      this.loadMotos();
      // this.verificarStatusCaixa();
    },
  },
  computed: {
    relatorioExcel() {
      return this.lista.map((item) => {
        return {
          Data: moment(item.data).format("DD/MM/YYYY HH:mm"),
          Código: item.cod,
          Tipo: item.tipo,
          Identificação: item.ident,
          Forma: item.pagamento,
          Valor: item.total,
        };
      });
    },
    porForma() {
      return this.lista.reduce((acc, item) => {
        if (!acc[item.pagamento]) {
          acc[item.pagamento] = 0;
        }
        acc[item.pagamento] += item.total;
        return acc;
      }, {});
    },
  },
  methods: {
    async loadMotos() {
      let res = await CaixaLib.getMotosControle(
        this.empresaSelecionada.cod_empresa,
        this.data,
        null
      );
      this.motos = res;
      console.log("motos==>", this.motos);
    },
    async printFita() {
      // let fechamento = await CaixaLib.getAll({
      //   cod_empresa: this.empresaSelecionada.cod_empresa,
      //   cod_caixa: this.caixaSelecionado.cod_caixa,
      //   data: this.data,
      // });
      // console.log("fechamento", fechamento);
      await CaixaLib.printFita({
        // cod_fechamento: fechamento && fechamento.length>0?fechamento[0].cod_fechamento:0,
        cod_empresa: this.empresaSelecionada.cod_empresa,
        cod_caixa: this.caixaSelecionado ? this.caixaSelecionado.cod_caixa : 1,
        data: this.data,
        print: true,
      });
      this.$swal("Impressão solicitada!", "", "success");
    },
    async selectCaixa(cx) {
      console.log(
        "cx",
        cx,
        this.caixas,
        this.empresaSelecionada,
        this.caixaSelecionado
      );
      this.caixaSelecionado = this.caixas.find((x) => x.cod_caixa == cx);
      console.log("caixaSelecionado", this.caixaSelecionado);
      // this.loadData();
      // this.verificarStatusCaixa();
      this.verificarAberturaCaixa();
    },
    async selectEmpresa(emp) {
      console.log("emp", emp);
      this.empresaSelecionada = this.empresas.find((x) => x.cod_empresa == emp);
      console.log("sel", this.empresaSelecionada);
      this.caixas = await CaixaLib.getAll(this.empresaSelecionada);
      // this.caixaSelecionado = this.caixas[0];
      this.selectCaixa(this.caixas[0].cod_caixa);

      this.loadData();
    },
    print() {
      PrinterWindowHelper(document.querySelector("#printDiv").innerHTML);
    },
    async loadData() {
      this.loading = true;
      try {
        this.lista = [];
        let res = await CaixaLib.getListagemCaixa({
          cod_empresa: this.empresaSelecionada.cod_empresa,
          cod_caixa: this.caixaSelecionado
            ? this.caixaSelecionado.cod_caixa
            : 1,
          data: this.data,
        });
        if (res && res.success) {
          this.lista = res.data;
        }

        this.verificarAberturaCaixa();
      } catch (error) {
        console.log("error on loadData", error);
      }

      this.loading = false;
    },
    async carregaCaixas() {
      this.$forceUpdate();
      await this.$nextTick();
      this.loadingCaixa = true;
      this.caixas = [];
      // if (this.empresa) {
      console.log("carregaCaixas", this.empresa);
      this.caixas = await CaixaLib.getAll(
        this.empresaSelecionada ? this.empresaSelecionada.cod_empresa : 1
      );
      // this.caixaSelecionado = this.caixas[0];
      // }
      this.loadMotos();
      this.loadingCaixa = false;
    },
    async carregaEmpresas() {
      this.loadingEmpresa = true;
      this.empresas = await EmpresasLib.getResumo();
      this.loadingEmpresa = false;
    },
    async openPedido(pedido) {
      if (pedido && pedido.length > 0) {
        pedido = pedido[0];
        console.log("pedido", pedido);
        this.$refs.tbLista.clearSelected();

        if (pedido.tipo == "Mesa") {
          let result = await Mesalib.getMesaControle(pedido.cod_complemento);
          console.log("result", result);
          if (result && result.length > 0) {
            this.mesaSelected = result[0];
            this.$bvModal.show("modal-open-comanda");
          } else {
            this.$bvToast.toast("Mesa não encontrada", {
              title: "Erro",
              variant: "danger",
              solid: true,
            });
          }
        } else {
          let result = await PedidoLib.get({
            cod_pedido: pedido.cod_complemento,
          });
          console.log("result pedido", result);
          if (result && result.success) {
            this.pedidoSelected = result.data[0];
            this.$bvModal.show("modal-open-pedido");
          }
        }
      }
    },
    async verificarAberturaCaixa(tipo) {
      console.log("verificarAberturaCaixa", this.caixaSelecionado);
      if (
        !this.empresaSelecionada ||
        !this.empresaSelecionada.cod_empresa ||
        !this.caixaSelecionado ||
        !this.caixaSelecionado.cod_caixa
      ) {
        return;
      }

      console.log(
        "finding",
        this.empresaSelecionada.cod_empresa,
        moment().format("YYYY-MM-DD"),
        this.caixaSelecionado.cod_caixa
      );
      let caixaControle = [];

      caixaControle = await CaixaLib.getFechamentos(
        this.empresaSelecionada.cod_empresa,
        moment()
          .add(parseInt(moment().format("HH") < 8 ? -1 : 0), "d")
          .format("YYYY-MM-DD"),
        this.caixaSelecionado.cod_caixa,
        true
      );

      console.log("caixaControle", caixaControle);
      if (caixaControle.length <= 0 || tipo == 1) {
        // this.$bvModal.show("modal-open-caixa");
        // return;
        const convertRealToFloat = (vl) => {
          if (!vl) return 0;
          vl = parseFloat(
            vl.toString().replace("R$", "").replace(".", "").replace(",", ".")
          );
          // console.log(!vl || vl == "NaN" ? 0 : vl);
          return !vl || vl == "NaN" ? 0 : vl;
        };

        const convertFloatToReal = (vl) => {
          if (!vl) return "R$0,00";
          vl = vl.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          });
          return vl;
        };

        this.$swal({
          title: tipo == 1 ? "Alterar Abertura" : "Caixa não aberto!",
          html: `
            <div class="form-group">
              <label>Fundo de Caixa / Troco</label>
              <input 
                id="swal-money-input" 
                class="form-control p-3" 
                value="${
                  tipo == 1
                    ? convertFloatToReal(this.caixaControle.vl_aberto)
                    : "0,00"
                }"
                v-bind="money"
                oninput="
                  // Allow only numbers and formatting characters
                  this.value = this.value.replace(/[^0-9,.]/g, '');
                  
                  // Format as currency
                  const numValue = this.value.replace(/[^0-9]/g, '');
                  if (numValue) {
                    const floatValue = parseFloat(numValue) / 100;
                    this.value = floatValue.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                      minimumFractionDigits: 2
                    });
                  } else {
                    this.value = 'R$ 0,00';
                  }
                "
              />
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: tipo == 1 ? "Alterar" : "Abrir Caixa",
          cancelButtonText: "Cancelar",
          preConfirm: () => {
            const inputValue =
              document.getElementById("swal-money-input").value;
            try {
              let v = convertRealToFloat(inputValue);
              if (isNaN(v) || v <= 0) {
                this.$swal.showValidationMessage("Informe um valor válido!");
                return false;
              }
              return inputValue;
            } catch (error) {
              console.log("error", error);
              this.$swal.showValidationMessage("Informe um valor válido!");
              return false;
            }
          },
        }).then(async (result) => {
          if (result.isConfirmed && result.value) {
            console.log("Valor:", result.value);
            const valor = convertRealToFloat(result.value);

            // Aqui você adiciona a lógica para abrir o caixa
            try {
              await CaixaLib.storeFechamento({
                fechamento: {
                  cod_empresa: this.empresaSelecionada.cod_empresa,
                  cod_caixa: this.caixaSelecionado
                    ? this.caixaSelecionado.cod_caixa
                    : 1,
                  dt_caixa: moment(this.data).format("YYYY-MM-DD"),
                  data: moment(this.data).format("YYYY-MM-DD"),
                  cod_usuario:
                    caixaControle.length > 0
                      ? caixaControle[0].cod_usuario
                      : this.$store.state.auth.user.cod_usuario,
                  dt_cadastro:
                    caixaControle.length > 0
                      ? moment(caixaControle[0].dt_cadastro).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      : moment().format("YYYY-MM-DD HH:mm:ss"),
                  vl_aberto: valor,
                  cod_usuario_cadastro:
                    caixaControle.length > 0
                      ? caixaControle[0].cod_usuario_cadastro
                      : this.$store.state.auth.user.cod_usuario,
                  cod_fechamento:
                    caixaControle.length > 0
                      ? caixaControle[0].cod_fechamento
                      : null,
                  cod_usuario_alterado: this.$store.state.auth.user.cod_usuario,
                },
              });
              this.$swal(
                tipo == 1
                  ? "Abertura alterada com sucesso!"
                  : "Caixa aberto com sucesso!",
                "",
                "success"
              );
              this.verificarAberturaCaixa();
              this.loadData();
            } catch (error) {
              console.error("Erro ao abrir caixa:", error);
              this.$swal("Erro ao abrir caixa!", "", "error");
              this.verificarAberturaCaixa();
            }
          } else {
            // this.$swal({
            //   title: "Caixa não aberto!",
            // }).then(() => {
            // });
            // this.verificarAberturaCaixa();
          }
        });
      } else {
        this.$bvModal.hide("modal-open-caixa");
        this.valorAbertura = caixaControle[0].vl_aberto;
        this.caixaAberto = true;
        this.caixaControle = caixaControle[0];
      }

      this.loadSaidas();
    },
    cancelFechamento() {
      this.$swal({
        title: "Re-abrir Caixa",
        text: "Tem certeza que deseja re-abrir o caixa?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, re-abrir caixa",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await CaixaLib.storeFechamento({
            fechamento: {
              cod_fechamento: this.caixaControle.cod_fechamento,
              dt_fechamento: null,
              cod_usuario_alterado: this.$store.state.auth.user.cod_usuario,
            },
          });
          this.$swal("Caixa re-aberto com sucesso!", "", "success");
          this.verificarAberturaCaixa();
          this.loadData();
        }
      });
    },

    async openModalAbertura(tipo) {
      if (!this.caixaControle || tipo == 1) {
        this.verificarAberturaCaixa(1);
      } else {
        this.$swal({
          title: "Fechar Caixa",
          text: "Tem certeza que deseja fechar o caixa?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim, fechar caixa",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await CaixaLib.storeFechamento({
                fechamento: {
                  cod_fechamento: this.caixaControle.cod_fechamento,
                  dt_fechamento: moment().format("YYYY-MM-DD HH:mm:ss"),
                  cod_usuario_alterado: this.$store.state.auth.user.cod_usuario,
                },
              });
              this.$swal("Concluído!", "Caixa fechado com sucesso.", "success");
              this.caixaAberto = false;
              this.caixaControle = null;
              this.verificarAberturaCaixa();
            } catch (error) {
              console.error("Erro ao fechar caixa:", error);
              this.$swal("Erro", "Não foi possível fechar o caixa.", "error");
            }
          }
        });
      }
    },
    openModalSangria() {
      this.$bvModal.show("modal-sangria");
    },
    resetModalAbertura() {
      this.valorAbertura = "R$0,00";
      this.obsAbertura = "";
    },
    resetModalSangria() {
      this.valorSangria = "R$0,00";
      this.motivoSangria = "";
      this.saidaEmEdicao = null;
    },
    async confirmarAberturaCaixa(bvModalEvent) {
      bvModalEvent.preventDefault();
      try {
        if (this.caixaAberto) {
          // Fechar caixa
          await CaixaLib.storeCaixaControle({
            cod_empresa: this.empresaSelecionada.cod_empresa,
            cod_caixa: this.caixaSelecionado
              ? this.caixaSelecionado.cod_caixa
              : 1,
            data: this.data,
            // data_abertura: this.data,
            data_fechamento: this.data,
            // vl_aberto: this.valorAbertura,
            // valor_fechamento: this.valorAbertura,
            // obs_abertura: this.obsAbertura,
            // obs_fechamento: this.obsAbertura,
          });
          this.$swal("Caixa fechado com sucesso!", "", "success");
        } else {
          // Abrir caixa
          await CaixaLib.storeCaixaControle({
            cod_empresa: this.empresaSelecionada.cod_empresa,
            cod_caixa: this.caixaSelecionado
              ? this.caixaSelecionado.cod_caixa
              : 1,
            data: this.data,
            data_abertura: this.data,
            data_fechamento: null,
            vl_aberto: this.valorAbertura,
            valor_fechamento: null,
            obs_abertura: this.obsAbertura,
            obs_fechamento: null,
          });
          this.$swal("Caixa aberto com sucesso!", "", "success");
        }
        this.$bvModal.hide("modal-abertura-caixa");
        this.verificarStatusCaixa();
        this.loadData();
      } catch (error) {
        console.error("Erro ao processar operação de caixa:", error);
        this.$swal(
          "Erro ao processar operação!",
          "Verifique os logs para mais detalhes",
          "error"
        );
      }
    },
    async confirmarSangria(bvModalEvent) {
      bvModalEvent.preventDefault();
      try {
        if (!this.caixaControle || this.caixaControle.dt_fechamento !== null) {
          this.$swal("Caixa não aberto!", "", "error");
          return;
        }
        if (this.valorSangria <= 0) {
          this.$swal("Valor da sangria inválido!", "", "error");
          return;
        }

        const dadosSangria = {
          cod_empresa: this.empresaSelecionada.cod_empresa,
          cod_caixa: this.caixaSelecionado
            ? this.caixaSelecionado.cod_caixa
            : 1,
          data: moment(this.data).format("YYYY-MM-DD ") + moment().format("HH:mm:ss"),
          valor: this.valorSangria,
          motivo: this.motivoSangria,
          // tipo: "SANGRIA"
        };

        if (this.saidaEmEdicao) {
          dadosSangria.cod_saida = this.saidaEmEdicao.cod_saida;
        }

        await CaixaLib.storeSaida(dadosSangria);
        this.saidaEmEdicao = null;
        this.$swal(
          this.saidaEmEdicao
            ? "Sangria atualizada com sucesso!"
            : "Sangria registrada com sucesso!",
          "",
          "success"
        );
        this.$bvModal.hide("modal-sangria");
        this.loadSaidas();
      } catch (error) {
        console.error("Erro ao registrar sangria:", error);
        this.$swal(
          "Erro ao registrar sangria!",
          "Verifique os logs para mais detalhes",
          "error"
        );
      }
      this.loadSaidas();
    },
    async loadSaidas() {
      this.saidas = await CaixaLib.getSaida(
        this.empresaSelecionada.cod_empresa,
        "caixa",
        this.caixaSelecionado.cod_caixa,
        this.data
      );
    },
    editarSaida(saida) {
      this.saidaEmEdicao = saida;
      this.valorSangria = saida.valor;
      this.motivoSangria = saida.motivo || "";
      this.$bvModal.show("modal-sangria");
    },
    async excluirSaida(saida) {
      try {
        this.$swal({
          title: "Excluir Sangria",
          text: "Tem certeza que deseja excluir esta sangria?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim, excluir",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await CaixaLib.delSaida(saida);
            this.$swal("Sangria excluída com sucesso!", "", "success");
            this.loadSaidas();
          }
        });
      } catch (error) {
        console.error("Erro ao excluir sangria:", error);
        this.$swal("Erro ao excluir sangria!", "", "error");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
